import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZomatoComponent } from './simple-icons-zomato.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZomatoComponent ],
    exports:      [ SimpleIconsZomatoComponent ],
    bootstrap:    []
})
export class SimpleIconsZomatoModule {}
